class Validation {
    constructor(keys) {
        this.errorMsgs = {}
        for (var i = 0; i < keys.length; i++) {
            const key = keys[i];
            this.errorMsgs[key] = '';
        }
    }

    validate(rules, key, input) {
        for (var i = 0; i < rules.length; i++) {
            const rule = rules[i];
            const ruleResult = this[rule](input);
            if (!ruleResult.valid) this.errorMsgs[key] = ruleResult.message;
            else this.errorMsgs[key] = ''; //All good.
        }
    }

    allValid() {
        for (var key in this.errorMsgs)
            if (this.errorMsgs[key] !== '') return false;
        return true;
    }

    errorMsg(key) {
        return this.errorMsgs[key];
    }

    notEmpty(str) {
        return {
            valid: !(str.trim() === ''),
            message: 'Fältet får ej vara tomt.'
        };
    }

    email(str) {
        return {
            valid: (str.indexOf('@') >= 0),
            message: 'Måste vara en giltig e-postadress.'
        };
    }

    orgNumber(str) {
        var split = str.split('-');
        var valid = false;
        if (split.length === 2) {
            valid = ((split[0].length === 6 || split[0].length === 8) &&
                (split[1].length === 4) && !parseInt(split[0], 10).isNaN() &&
                !parseInt(split[1], 10).isNaN());
        } else {
            valid = ((split[0].length === 10 || split[0].length === 12) &&
                !parseInt(split[0], 10).isNaN());
        }
        return {
            valid: valid,
            message: 'Inte ett giltigt organisationsnummer.'
        };
    }

    match(list) {
        const original = list[0]
        let valid = true;
        for (var i = 0; i < list.length; i++) {
            if (list[i] !== original) valid = false;
        }
        return {
            valid: valid,
            message: 'Lösenorden matchar inte'
        };
    }

    validPassword(value) {
        return {
            valid: !(value.length < 8),
            message: 'Lösenordet måste bestå minst av 8 tecken.'
        }
    }

    postalCode(value) {
        return {
            valid: this._postalCode(value),
            message: 'Postnummer måste bestå av 5 siffror. Exempel: 999 99'
        }
    }

    _postalCode(value) {
        //Remove all whitespace
        value = value.trim().replace(/\s/g, "");
        //Check if it contains digit && check if the length is 5
        return /^\d+$/.test(value) && value.length === 5;
    }

}

module.exports = Validation;



// WEBPACK FOOTER //
// ./src/lib/Validation.js